import { render, staticRenderFns } from "./AudienceSelect.vue?vue&type=template&id=572c6e2a"
import script from "./AudienceSelect.vue?vue&type=script&lang=js"
export * from "./AudienceSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports